import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../AuthContext';
import { choiceFor, clearPendingPick, pendingPick } from '../lib/market';

/**
 * Hands the country a visitor picked on the front door to the server, once, when they sign in or sign up, so Browse opens on that
 * country's jobs (`PUT /api/candidate/jobs/market`, saved as their own choice, which comes before every other default).
 *
 * Only a pick the visitor made counts: a country worked out from the browser's language is left to the server's own order (their
 * application answers, then their time zone). The pick is handed over once and then forgotten as pending, so a later change made in
 * Browse is never undone by a stale pick from before. A sign-in that cannot save it (a hiring account has no job search) drops it.
 */
const MarketSync = () => {
  const { user } = useAuth();
  const sent = useRef(false);

  useEffect(() => {
    if (!user?.id || sent.current) return;
    const pick = pendingPick();
    if (!pick) return;
    sent.current = true;
    axios.put('/api/candidate/jobs/market', { country: choiceFor(pick) })
      .then(() => clearPendingPick())
      .catch((error) => {
        // A refusal will not change on a retry; a dropped connection might, on the next sign-in.
        if (error?.response) clearPendingPick();
      });
  }, [user?.id]);

  return null;
};

export default MarketSync;
